import React from 'react';
import PropTypes from 'prop-types';
import tinycolor from 'tinycolor2';
import styles from './ProgressSpinner.m.sass';
var getIconStyle = function getIconStyle(_ref) {
  var color = _ref.color,
    size = _ref.size,
    thickness = _ref.thickness,
    blue = _ref.blue;
  if (blue) {
    color = '#2395F3';
  }
  var $color = tinycolor(color);
  var $offColor = $color.clone().setAlpha(0.2);
  return {
    borderColor: $offColor,
    borderTopColor: $color,
    width: size,
    height: size,
    borderWidth: thickness
  };
};
var ProgressSpinner = function ProgressSpinner(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.icon,
    style: getIconStyle(props)
  }));
};
ProgressSpinner.defaultProps = {
  color: '#fff',
  size: 24,
  thickness: 3
};
ProgressSpinner.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  thickness: PropTypes.number,
  blue: PropTypes.bool
};
export default ProgressSpinner;
//# sourceMappingURL=index.js.map
